import { render, staticRenderFns } from "./DetailHeader.vue?vue&type=template&id=a827c520"
import script from "./DetailHeader.vue?vue&type=script&lang=js"
export * from "./DetailHeader.vue?vue&type=script&lang=js"
import style0 from "./DetailHeader.vue?vue&type=style&index=0&id=a827c520&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports